import React from 'react';

class Somos extends React.Component{

    render(){
        return(
            <div className="container-fluid mt-2 mb-3">
                <div className="col-12">
                    <h4 className="text-center">Arquiproductos, la plataforma de productos de diseño y arquitectura</h4>
                </div>

                <br></br>

                <div className="col-10 mx-auto">
	            <p className="font-weight-bold">¿Qué es ARQUIPRODUCTOS.COM?</p>
	            <p>Arquiproductos es una plataforma vertical de comercio en línea B2B dirigida a la industria del diseño y arquitectura, perteneciente al grupo Pull Creativo Comunicaciones, el cual también es encargado de la organización anual de la feria Expodeco (Salón Internacional de Diseño y Arquitectura), junto al medio de comunicación Dossier ( Portal de contenidos).</p>
	            </div>	

	            <br></br>

                <div className="col-10 mx-auto">
	            <p className="font-weight-bold">¿Qué puede obtener de ARQUIPRODUCTOS.COM?</p>
	            <p>Las últimas noticias e información sobre el  diseño, decoración y arquitectura nacional e internacional,  encontrar de forma ordenada productos de los siguientes rubros: acabados, mobiliario, baños, cocina, decoración, iluminación, jardín, materiales, pisos, puertas, griferías, sanitarios, alfombras, cortinas, luminaria, mesas y sillas, muebles, etc.</p>
	            <p>Cuenta con una amplia cartera de proveedores del Perú y el mundo participando de la plataforma Arquiproductos.com.</p>

                <br></br>
                </div>	

                <div className="col-10 mx-auto">
	            <p className="font-weight-bold">Servicios de ARQUIPRODUCTOS.COM</p>
	            <p>Crear oportunidades comerciales tanto para compradores como para proveedores, impulsando la interacción entre las dos partes, desarrolla productos y servicios que satisfagan bien las demandas comerciales, brindando soluciones comerciales.</p>
	            <p>Ayudan a los proveedores a comercializar productos de manera eficiente los 365 días del año para la captura de mayores oportunidades de compra. Cuenta con una comunidad de clientes profesionales y usuarios de calidad, desarrollada en la plataforma online y en la exhibición fuera de esta.

				Mantiene a su público al tanto de la dinámica del mercado y las tendencias de la industria para un mejor análisis comercial.</p>
	            </div>	

	            <br></br>
	            <div className="col-10 mx-auto">
                    <h5 className="text-center">Si tiene alguna pregunta acerca de ARQUIPRODUCTOS.COM u otra ayuda para su publicidad o información, <a href={`publicidad`}> contáctenos en aquí </a></h5>
                </div>

            </div>

          
        )
    }
}

export default Somos;